import React from 'react';
import './Main.scss';
import Logo from '../../assets/Logo.svg';
import NotFoundImage from '../../assets/not-found.svg';

const MainPage = () => {
    return (
        <div className="main-page-container">
            <div className="main-content">
                <div className="logo-container">
                    <img src={Logo} alt="Kan Logo" className="logo" />
                </div>
                <div className="not-found-image-container">
                    <img src={NotFoundImage} alt="Page Not Found" className="not-found-image" />
                </div>
                <h1> אופס! הדף שחיפשת לא קיים.</h1>
                <p>יש להיכנס עם הקישור שקיבלת ו/או ליצור קשר עם הגורם שהפנה אותך.</p>
                {/* <h1>כאן טפסים - גישה חיצונית</h1>
                <div className="info-box">
                    <h2>🔒 גישה מוגבלת</h2>
                    <p>דף זה מיועד לגישה באמצעות קישור ישירות לטופס בלבד.</p>
                    <p>אם קיבלת קישור לטופס במייל, אנא השתמש בקישור הישיר שנשלח אליך.</p>

                    <div className="example">
                        <strong>דוגמה לקישור תקין:</strong>
                        <code>https://forms.kan.org.il/new-application/[APPLICATION_ID]</code>
                    </div>
                </div>

                <div className="contact-info">
                    <h3>זקוק לעזרה?</h3>
                    <p>אם אתה נתקל בבעיות, אנא פנה למנהל המערכת או אל הגורם ששלח לך את הקישור לטופס.</p>
                </div> */}
            </div>
        </div>
    );
};

export default MainPage;
